import React from 'react'
import { useAppSelector } from '../../../../hooks/redux'
import _ from 'lodash'
import { type RootState } from '../../../../store/store'

import ProfileCard from "../../../../components/shared/search/search-results/profile-card";

export interface AgentInfoForChildrenProps {
    userID: number
}
const AgentInfoForChildren = ({ userID }: AgentInfoForChildrenProps): JSX.Element => {

    const allUsers = useAppSelector((state: RootState) => state.user.allUsers)
    const agentUser = _.find(allUsers, (user) => user.id === userID)
    let agentDocs: any = []
    if (Array.isArray(agentUser?.Documents)) {
        agentDocs = agentUser?.Documents
    }



    return (
        agentUser != null
            ?
            <div>
                <ProfileCard user={agentUser} showUserType={true} />
            </div>
            : <></>
    )
}

export default AgentInfoForChildren
